import '../../assets/scss/content/content.scss'
import text from './text.json'
import {ImgButton} from '../../components/core/button'
import {ContentEmptyIcon, PlusIcon} from '../../icons'
import {setModalIsActive} from '../../stores/resources'
import {useDispatch, useSelector} from 'react-redux'
import classNames from 'classnames'

const EmptyContent = ({message, hideButton, buttonText, onclick, icon, showIcon = true}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()
    const openModal = () => {
        dispatch(setModalIsActive(true))
    }
    return (
        <div className={classNames('empty-content-body', {
            dark: isDarkMode
        })}>
            {icon || <ContentEmptyIcon/>}
            <p>{message || text.content_empty}</p>
            {!hideButton && (
                <ImgButton onClick={onclick || openModal} className={classNames({

                    'button-centered': !showIcon
                })}>
                    {buttonText || text.add_monitoring}
                    {showIcon && <span><PlusIcon/></span>}
                </ImgButton>
            )}
        </div>
    )
}

export default EmptyContent
